import { Button } from "@mantine/core";
import { IconArrowUpRight } from "@tabler/icons-react";
import { useState } from "react";
import { generatePath, useNavigate, useParams } from "react-router";
import { ROUTES } from "../../../../../routes";

const ContractType = {
  dv: {
    label: "Vermarktungsvertrag",
    route: ROUTES.vermarktung.entry
  },
  p6: {
    label: "§6 EEG Vertrag",
    route: ROUTES.paragraph6.entry
  }
} as const;

interface ContractsAssignmentProps {
  done: boolean;
  objectsAreMissing: boolean;
  isDisabled: boolean;
  updateSiteWizard: () => Promise<void>;
  contractType: keyof typeof ContractType;
}

function ContractsAssignment({
  done,
  objectsAreMissing,
  updateSiteWizard,
  isDisabled,
  contractType
}: ContractsAssignmentProps) {
  const navigate = useNavigate();

  const [isSpinning, setIsSpinning] = useState(false);

  const { projectId } = useParams();

  const contractsUrl = projectId
    ? generatePath(ContractType[contractType].route, {
        projectId: projectId
      })
    : undefined;

  function onClickSubmit() {
    setIsSpinning(true);
    updateSiteWizard().finally(() => {
      setIsSpinning(false);
    });
  }

  const buttonColor = "neutral";
  const buttonVariant = "outline";

  if (done) {
    return (
      <Button color="neutral" disabled variant="outline">
        Erledigt ({ContractType[contractType].label})
      </Button>
    );
  }

  if (objectsAreMissing) {
    return (
      <Button
        color={buttonColor}
        disabled={isDisabled || !contractsUrl}
        rightSection={<IconArrowUpRight size={16} />}
        variant={buttonVariant}
        onClick={() => contractsUrl && navigate(contractsUrl)}
      >
        {ContractType[contractType].label} anlegen
      </Button>
    );
  }

  // no objects missing and not done
  return (
    <Button
      color={buttonColor}
      disabled={isDisabled}
      loading={isSpinning}
      styles={{
        label: {
          whiteSpace: "normal"
        }
      }}
      variant={buttonVariant}
      onClick={onClickSubmit}
    >
      {ContractType[contractType].label} als erledigt markieren
    </Button>
  );
}

export { ContractsAssignment };
